<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <!-- External Id Control -->
    <div class="form-group">
      <label for="{{ baseId }}-id" translate>ID</label>
      <input
        id="{{ baseId }}-id"
        class="form-control"
        [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
        formControlName="externalId"
      />
      <div *ngIf="showErrors(externalIdControl, isSubmitted)" id="{{ baseId }}-warning-text-id" class="incorrect-input" translate>
        {{ externalIdControl.errors | fcListValidation : 'ID' }}
      </div>
    </div>
    <!-- External Id Control -->

    <!-- Name Control -->
    <div class="form-group">
      <label for="{{ baseId }}-name" translate>Name</label>
      <input
        id="{{ baseId }}-name"
        class="form-control"
        [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.Name.MaxLength"
        formControlName="name"
      />
      <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name" translate>
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        formControlName="notes"
        rows="3"
      >
      </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input" translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <!-- Notes Control -->

    <div class="flex-row-generic">
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-insurance-plan-payer-label" translate>Insurance Plan Payer</label>
        <ap-findcontrol
          id="{{ baseId }}-insurance-plan-payer"
          controlName="insurancePlanPayer"
          [baseId]="baseId"
          [apFormGroup]="form"
          [(selectedPks)]="selectedInsurancePlanPayerControlPks"
          [placeHolder]=""
          [form]="form"
          [findControlId]="FindControlIdService.ViewPayerPlan"
          [singleSelect]="true"
          (chipsChange)="onInsurancePlanDataPopulate($event)"
          findControlDisplayName="Find Insurance Plan"
          [required]="getFindControlValidation('InsurancePlanPayer')"
          (dirty)="insurancePayerPlanUidControl.markAsDirty()"
          [formGroupSubmitted]="isSubmitted"
        >
        </ap-findcontrol>
      </div>
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-lab-partner" translate>Lab Partner</label>
        <ap-findcontrol
          id="{{ baseId }}-hl-7-partner"
          controlName="hl7Partner"
          [baseId]="baseId"
          [apFormGroup]="form"
          [(selectedPks)]="selectedHl7PartnerControlPks"
          [placeHolder]=""
          [form]="form"
          [findControlId]="FindControlIdService.HL7Partner"
          [singleSelect]="true"
          (chipsChange)="onHl7PartnerDataPopulate($event)"
          findControlDisplayName="Find HL-7 Partner"
          [required]="getFindControlValidation('HL7Partner')"
          (dirty)="hl7PartnerUidControl.markAsDirty()"
          [formGroupSubmitted]="isSubmitted"
        >
        </ap-findcontrol>
      </div>
    </div>

    <!-- Inactive and User Defined checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive</mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined</mat-checkbox>
    </div>
    <!-- Inactive and User Defined checkboxes -->
  </div>
</fc-general-modal>
